<template>
   <adminAccountManager></adminAccountManager>
</template>
<script>
import adminAccountManager from '../../comComponent/adminAccountManager'
export default {
  data () {
    return {

    }
  },
  mounted () {

  },
  components: {
    adminAccountManager
  },
  methods: {

  }
}
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/modules/enterpriseAdmin/accountManager/adminAccount.vue